import React, { useCallback, useEffect, useRef, useState } from 'react';
import { copyTextToClipboard } from '../utils/copyToClipboard';

export default function CopyShareLinkButton({ text, className = '', onCopied, onFailed }) {
  const [copied, setCopied] = useState(false);
  const resetTimerRef = useRef(null);

  useEffect(
    () => () => {
      if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
    },
    []
  );

  const handleCopy = useCallback(async () => {
    const ok = await copyTextToClipboard(text);
    if (!ok) {
      onFailed?.();
      return;
    }
    setCopied(true);
    onCopied?.();
    if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
    resetTimerRef.current = setTimeout(() => setCopied(false), 2200);
  }, [text, onCopied, onFailed]);

  return (
    <button
      type="button"
      className={`sb-copy-link-btn${copied ? ' sb-copy-link-btn--copied' : ''} ${className}`.trim()}
      onClick={handleCopy}
      disabled={!text}
      aria-live="polite"
    >
      {copied ? 'Copied' : 'Copy'}
    </button>
  );
}
